import { Route } from "react-router";
import { all_routes } from "./all_routes";
import Login from "../auth/login/login";
import Register from "../auth/register/register";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";

import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";

import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import LockScreen from "../auth/lockScreen";
import UnderConstruction from "../pages/underConstruction";
// admin
import AdminTrackCaseProgram from "../admin/track-case-program";
import AdminInsufficiencyDetails from "../admin/track-case-program/hr-pending-action/InsufficiencyDetails";
import AdminCaseDetails from "../admin/track-case-program/work-in-progress/CaseDetails";
import AdminStopCheck from "../admin/track-case-program/work-in-progress/StopCheck";

import AddCheck from "../admin/track-case-program/work-in-progress/AdminAddCheck";
import HrPendingAction from "../admin/track-case-program/HrPendingAction";
import RevisedDateCases from "../admin/track-case-program/RevisedDateCases";
import AdminAddVerifier from "../admin/account-settings/verifier/AdminAddVerifier";
import AdminAddManager from "../admin/account-settings/AdminAddManager";
import AccountManageUser from "../admin/account-settings/AccountManageUser";
import ManageAssignedManagerPrograms from "../admin/account-settings/ManageAssignedManagerPrograms";
import LOBList from "../admin/LOBList";
import Admin_ManageVerifier from "../admin/account-settings/verifier/Admin_ManageVerifier";
import Admin_ManageVerifierCases from "../admin/account-settings/verifier/Admin_ManageVerifierCases";

// manager vishnu
import ManagerHrPendingAction from "../manager/hr-action/ManagerHrPendingAction";
import ManagerLOBList from "../manager/ManagerLOBList";
import ManagerAddVerifier from "../manager/account-settings/ManagerAddVerifier";
import Manager_ManageVerifier from "../manager/account-settings/Manager_ManageVerifier";
import ManageVerifierCases from "../manager/account-settings/ManageVerifierCases";
import ManagerTrackCaseProgram from "../manager/live-case-progress";
import ManagerInsufficiencyDetails from "../manager/hr-action/InsufficiencyDetails";
import ManagerCaseDetails from "../manager/live-case-progress/CaseDetails";

// verifier zeeshan
import VerifierTrackCaseProgram from "../verifier/track-case-program";
import VerifierInsufficiencyDetails from "../verifier/track-case-program/hr-pending-action/InsufficiencyDetails";
import VerifierHrPendingAction from "../verifier/track-case-program/HrPendingAction";
import VerifierCaseDetails from "../verifier/track-case-program/work-in-progress/CaseDetails";
import VerifierStopCheck from "../verifier/track-case-program/work-in-progress/StopCheck";
import Admin_AddArtifacts from "../admin/track-case-program/work-in-progress/Admin_AddArtifacts";
import Verifier_AddArtifacts from "../verifier/track-case-program/work-in-progress/Verifier_AddArtifacts";
import Manager_AddArtifacts from "../manager/live-case-progress/Manage_AddArtifacts";
import ManagerStopCheck from "../manager/live-case-progress/ManagerStopCheck";
import DynamicHome from "../DynamicHome";
import AdminAddCheck from "../admin/track-case-program/work-in-progress/AdminAddCheck";
import ManagerAddCheck from "../manager/live-case-progress/ManagerAddCheck";
import VerifierAddCheck from "../verifier/track-case-program/work-in-progress/VerifierAddCheck";
import Admin_ApplicantSubmission from "../admin/applicant-submissions-detail/Admin_ApplicantSubmission";
import Admin_CandidateApplicationDetails from "../admin/applicant-submissions-detail/Admin_CandidateApplicationDetails";
import Admin_ApplicantCaseTracking from "../admin/track-case-program/ApplicantCaseTracking";
import Verifier_ApplicantCaseTracking from "../verifier/track-case-program/ApplicantCaseTracking";
import Manager_ApplicantCaseTracking from "../manager/live-case-progress/ApplicantCaseTracking";
import AddMoreLOB from "../admin/account-settings/AddMoreLOB";
import AdminAsignCases from "../admin/account-settings/verifier/AdminAsignCases";
import ManagerAddArtifacts from "../manager/live-case-progress/ManagerAddArtifact";
import ManagerRaiseInsuff from "../manager/live-case-progress/ManagerRaiseInsuff";
import Profile from "../pages/profile";

const routes = all_routes;

export const publicRoutes = [
  // //////////////////////////////////////////////
  // ======= ADMIN AGENCY =======
  {
    path: routes.dashboard,
    element: <DynamicHome />,
    // element: <AdminTrackCaseProgram />,
    route: Route,
  },
  // {
  //   path: routes.admin_applicant_submissions,
  //   element: <Admin_ApplicantSubmission />,
  //   route: Route,
  // },
  {
    path: routes.admin_candidateApplicationDetails,
    element: <Admin_CandidateApplicationDetails />,
    route: Route,
  },

  {
    path: routes.admin_liveCaseProgress,
    element: <AdminTrackCaseProgram />,
    route: Route,
  },
  {
    path: routes.admin_hrActionRequired,
    element: <HrPendingAction />,
    route: Route,
  },
  {
    path: routes.admin_case_tracking,
    element: <Admin_ApplicantCaseTracking />,
    route: Route,
  },
  {
    path: routes.admin_assign_cases,
    element: <AdminAsignCases />,
    route: Route,
  },
  {
    path: routes.admin_revisedTatCase,
    element: <RevisedDateCases />,
    route: Route,
  },

  {
    path: `${routes.admin_caseDetails}`,
    element: <AdminCaseDetails />,
    route: Route,
  },
  {
    path: routes.admin_caseAddCheck,
    element: <AdminAddCheck />,
    route: Route,
  },
  {
    path: routes.admin_caseStopCheck,
    element: <AdminStopCheck />,
    route: Route,
  },

  {
    path: `${routes.admin_addArtifacts}`,
    element: <Admin_AddArtifacts />,
    route: Route,
  },

  {
    path: `${routes.admin_insufficiencyDetails}`,
    element: <AdminInsufficiencyDetails />,
    route: Route,
  },

  {
    path: routes.admin_addManager,
    element: <AdminAddManager />,
    route: Route,
  },
  {
    path: `${routes.manage_manager_programs}/:managerId`,
    element: <ManageAssignedManagerPrograms />,
  },

  {
    path: routes.admin_addVerifier,
    element: <AdminAddVerifier />,
    route: Route,
  },
  {
    path: routes.admin_manageVerifier,
    element: <Admin_ManageVerifier />,
    route: Route,
  },
  {
    path: `${routes.admin_verifier_cases}/:verifierId`,
    element: <Admin_ManageVerifierCases />,
  },

  {
    path: routes.admin_manageUser,
    element: <AccountManageUser />,
    route: Route,
  },
  {
    path: routes.add_more_lob_to_manager,
    element: <AddMoreLOB />,
    route: Route,
  },
  {
    path: routes.lobList,
    element: <LOBList />,
    route: Route,
  },
  // ======= /END ADMIN AGENCY =======
  // //////////////////////////////////////////////

  // ======= Manager Component  =======
  {
    path: routes.manager_case_tracking,
    element: <Manager_ApplicantCaseTracking />,
    route: Route,
  },
  {
    path: routes.manager_liveCaseProgress,
    element: <ManagerTrackCaseProgram />,
    route: Route,
  },
  {
    path: routes.manager_RaiseInsufficiency,
    element: <ManagerRaiseInsuff />,
    route: Route,
  },
  {
    path: routes.manager_caseDetails,
    element: <ManagerCaseDetails />,
    route: Route,
  },
  {
    path: routes.manager_caseStopCheck,
    element: <ManagerStopCheck />,
    route: Route,
  },
  {
    // path: `${routes.manager_addArtifacts}/:caseId/:assignId/:assingTempId`,
    path: `${routes.manager_addArtifacts}`,
    element: <Manager_AddArtifacts />,
    route: Route,
  },

  {
    path: routes.manager_caseAddCheck,
    element: <ManagerAddCheck />,
    route: Route,
  },
  {
    path: routes.manager_addArtifact,
    element: <ManagerAddArtifacts />,
    route: Route,
  },
  {
    path: routes.manager_HRActionRequired,
    element: <ManagerHrPendingAction />,
    route: Route,
  },
  {
    path: routes.manager_insufficiencyDetails,
    element: <ManagerInsufficiencyDetails />,
    route: Route,
  },
  {
    path: routes.manager_LobList,
    element: <ManagerLOBList />,
    route: Route,
  },
  {
    path: routes.manager_addVerifier,
    element: <ManagerAddVerifier />,
    route: Route,
  },

  {
    path: routes.manager_Verifier,
    element: <Manager_ManageVerifier />,
    route: Route,
  },
  {
    path: routes.manager_verifier_cases,
    element: <ManageVerifierCases />,
  },
  // ======= End Manager Component  =======

  // ======= Verifier Component  =======
  {
    path: routes.verifier_case_tracking,
    element: <Verifier_ApplicantCaseTracking />,
    route: Route,
  },
  {
    path: routes.verifier_liveCaseProgress,
    element: <VerifierTrackCaseProgram />,
    route: Route,
  },
  {
    path: routes.verifier_caseDetails,
    element: <VerifierCaseDetails />,
    route: Route,
  },
  {
    path: routes.verifier_caseStopCheck,
    element: <VerifierStopCheck />,
    route: Route,
  },
  {
    // path: `${routes.verifier_addArtifacts}/:caseId/:assignId/:assingTempId`,
    path: `${routes.verifier_addArtifacts}`,
    element: <Verifier_AddArtifacts />,
    route: Route,
  },
  {
    path: routes.verifier_caseAddCheck,
    element: <VerifierAddCheck />,
    route: Route,
  },

  {
    path: routes.verifier_HRActionRequired,
    element: <VerifierHrPendingAction />,
    route: Route,
  },
  {
    path: routes.verifier_insufficiencyDetails,
    element: <VerifierInsufficiencyDetails />,
    route: Route,
  },
   {
    path: routes.profile,
    element: <Profile />,
  },
  // ======= End Verifier Component  =======
];

export const authRoutes = [
  {
    path: routes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.register,
    element: <Register />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: routes.underConstruction,
    element: <UnderConstruction />,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
  },
];
